import { Component, OnDestroy, OnInit } from '@angular/core';
import { FileUploadDto, ResultListDto } from '../../../../service/dto';
import { BankDepositUploadDto } from '../../../../service/dto-insurance';
import { EMPTY, finalize, Subscription, switchMap } from 'rxjs';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { HttpFileService } from '../../../../service/http-file.service';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { HttpEventType } from '@angular/common/http';
import { HttpInsuranceBankDepositService } from '../../../../service/http-insurance-bank-deposit.service';

interface BankDeposit {
	date: string;
	reference: string;
	amount: number;
	description: string;
}

@Component({
  selector: 'app-bank-deposit-list',
  standalone: false,
  templateUrl: './bank-deposit-list.component.html',
  styleUrl: './bank-deposit-list.component.scss'
})
export class BankDepositListComponent implements OnInit, OnDestroy {
	uploadedFile?: FileUploadDto;
	uploadProgress?: number;

	data?: ResultListDto<BankDepositUploadDto>;
	pageIndex = 1;
	pageSize = 30;
	subscription = new Subscription();

	loading = false;
	columnRef: TableColumn[] = [

		{ "title": "ID", "property": "id" },
		{ "title": "Uploaded At", "cellRef": "refUploadedAt" },
		{ "title": "Agent", "cellRef": "refAgent" },
		{ "title": "Process Started At", "cellRef": "refProcessStartedAt" },
		{ "title": "Process Completed At", "cellRef": "refProcessCompletedAt" },

		{ "title": "Record Count", "property": "countOfRecords" },
		{ "title": "Successful Records", "property": "countOfSuccessfulRecords" },
		{ "title": "Failed Records", "property": "countOfFailedRecords" },
		{ "title": "Invalid Records", "property": "countOfInvalidRecords" },
		{ "title": "Total Deposit Amount", "property": "amount" },
	];


	constructor(
		private fileService: HttpFileService,
		private bankDepositService: HttpInsuranceBankDepositService,
		private fb: FormBuilder,
		private router: Router,
		private modal: NzModalService) {
	}
	ngOnInit(): void {
		this.doFetchUploads({ pageIndex: this.pageIndex, pageSize: this.pageSize, filters: [] });
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	customUpload = (item: NzUploadXHRArgs): any => {
		this.uploadProgress = 0;

		const subscription = this.fileService.uploadWithProgress(item.name ?? 'bank-payment-received', item.file as any)
			.pipe(
				finalize(() => this.uploadProgress = undefined),
				switchMap((event) => {
					if (event.type === HttpEventType.UploadProgress) {
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgress = percentage == 100 ? 99 : percentage;
					}
					if (event.type === HttpEventType.Response) {
						this.uploadProgress = 100;
						this.uploadedFile = event.body as FileUploadDto;
						return this.bankDepositService.createAndValidate((event.body as FileUploadDto).uuid);
					}
					return EMPTY;
				})
			)
			.subscribe({
				next: (result) => {
					this.router.navigate(['/bank-deposit', result.id, 'view']);
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
	doFetchUploads(input: OnTableChange) {
		this.pageIndex = input.pageIndex;
		this.pageSize = input.pageSize;
		this.loading = true;

		this.bankDepositService.getAll(this.pageIndex, this.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.data = result;
			});
	}
	doView(input: BankDepositUploadDto) {
		this.router.navigate(['/bank-deposit', input.id, 'view']);
	}
}
